;(function(w){
	function LightboxImagen(){
		self = this;
		this.main = document.getElementById('lightbox_imagen');

		var imagen = $(this.main).find('.image-holder .bg')[0];
		var caption = $(this.main).find('.caption')[0];
		var cerrar_btn = $(this.main).find('.bt-close')[0];

		$(cerrar_btn).bind('click', onClickCerrarBtn);

		this.mostrar = function(url_imagen, texto){
			$(imagen).css('background-image','url('+url_imagen+')');
			$(caption).html(texto);
			
			$(self.main).addClass('active');
		}

		this.ocultar = function(){
			$(self.main).removeClass('active');
		}

		function onClickCerrarBtn(e){

			self.ocultar();
		}
	}
	
	w.LightboxImagen = LightboxImagen;
})(window)